import React from "react"
import ItemModelV2 from "../../../../../../model2/item2/item-model"
import FieldProto from "../../../../../proto/field-proto"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type"
import {areJSONObjectPropsEqual} from "../../../../../../gd/utils/compare"
import StatusSummaryBar from "./summary"
import TasksView_Column from "../../../../../../model2/column/column"

type Props = {
    className?      : string
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto
}

// const debug = "FieldStatus_TableCellCalculated_NotHovered"
const debug = false

export default function FieldStatus_TableCellCalculated_NotHovered(props: Props) {

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const showSummaryView = props.listItem.view.isCollapsed &&
        !!calculatedValues?.total?.summary &&
        !areJSONObjectPropsEqual(calculatedValues.total.summary,calculatedValues.own.summary)

    debug && console.log(debug, "renderNotHovered", props.listItem.debugName, showSummaryView, calculatedValues)

    let notHoveredContent
    if (showSummaryView) {
        notHoveredContent = <StatusSummaryBar data={calculatedValues.total.summary!}/>
    } else {
        // Show nothing
    }

    const classes = Classes("cell-flex border-1px-transparent", {
        // 'is-expanded-calculated': props.listItem.isGroup && !props.listItem.view.isCollapsed
    })

    return (
        <div className      = {classes}
             style          = {props.style}>
            {notHoveredContent}
        </div>
    )
}
